import request from '@/services/base/request'

export default {
  doSignIn: (data: any) => request('/login/', 'post', data),
  sendSMSToLogin: (data: any) => request(`/login/${data.sessionId}/`, 'post', null),
  logout: (data: any) => request('/logout/', 'get', data),
  resetGA: (data: any) => request('/ga-backup-login/', 'post', data),
  doSignInKYC: (data: any) => request('kyc/kyc-login/', 'post', data)
} as {[key: string]: MethodDecorator}
